import {Component, inject} from '@angular/core';
import {AuthService} from '@core/services/auth.service';
import {Router} from '@angular/router';
import {AuthCard} from '@components/layout/auth/auth-card/auth-card';

@Component({
  selector: 'app-login',
  imports: [
    AuthCard
  ],
  standalone: true,
  templateUrl: './login.html',
  styleUrl: './login.css'
})
export class Login {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  onLoginInterno() {
    this.authService.login();
  }

  onLoginExterno() {
    sessionStorage.removeItem('concessionariasEmail');
    sessionStorage.removeItem('concessionariasEmailSent');
    this.router.navigate(['/auth/login-concessionarias']).then(r => r);
  }
}
